import { AfterViewChecked, AfterViewInit, Component, OnInit, Pipe, PipeTransform , ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as _ from "lodash";
import { element } from 'protractor';
import { takeUntil } from 'rxjs/operators';
import { Global } from 'src/app/Service/global.service';
import { PublicationsService } from 'src/app/Service/publications.service';
import { SharedService } from 'src/app/Service/shared.service';
declare var $: any

@Component({
  selector: 'app-societesautorisees',
  templateUrl: './societesautorisees.component.html',
  styleUrls: ['./societesautorisees.component.scss']
})
export class SocietesautoriseesComponent implements OnInit {
  port : any;
  prestation : any;
  currentlang = '';
  currentUrl;
  outputLg;
  slick: any = null;
  dataOffres: any[] = [];
  Id;
  isclicked = false;
  selectedOffre;
  OffresGlobals :any;
  dataOffresbrute = [];
  filter = {};
  description;
  descriptionFooter;
  langue;
  lenth;
  isArab=false;
  constructor(private global: Global,  private service: PublicationsService ,private shared: SharedService, private route: ActivatedRoute,private router: Router,private translate: TranslateService) { }

  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      this.isArab = lg.code == "ar";
      this.outputLg = lg;
      this.currentlang = lg.url;
      this.currentUrl = this.router.url
      this.langue = lg;

          this.isclicked = false;
          this.dataOffres = [];
          this.service.getSociteAutorisee().subscribe(data => {

            this.OffresGlobals = data;
            this.port = Array.from(new Set(this.OffresGlobals.map(element => element.port))).sort();
            this.prestation = Array.from(new Set(this.OffresGlobals.map(element => element.activite))).sort();
            this.lenth = this.OffresGlobals.length;
            this.dataOffres = this.OffresGlobals.filter(element => {return  element["Programme_region"]!=true});
            // this.dataOffres = this.OffresGlobals.filter(element => {return  element["Programme_region"]===false});
            this.dataOffres = this.dataOffres
              .map(offre => ({
                ...offre,
                dateValidite: this.converteDatevalidite(offre.dateValidite)
              }))
              .sort((a, b) => new Date(b.dateValidite).getTime() - new Date(a.dateValidite).getTime());
            
            this.dataOffresbrute = this.dataOffres;
            if (this.slick != null) {
              this.reload();
            } else {
              setTimeout(() => this.sliderAppel(), 100);
            }
          })

      this.shared.getBlocDescriptionByCode(lg.url, "societesautorisees").subscribe(data => {
        this.description = data["value"][0];
      })
    })
  }
  converteDatevalidite(dateValidite: any) {
    if (dateValidite) {
      const dateArray = dateValidite.split('-');
      return `${dateArray[0]}/${dateArray[1]}/${dateArray[2]}`;
    }
    return null;
  }
  converteDate(d: string) {
    return this.global.formattedDate(d);
  }
  capitize(string)
  {
    if(string) {
      return string.charAt(0) + string.slice(1).toLowerCase();
    }
    return null;
  }
  sliderAppel() {
    this.slick = $('#offres').dataTable({
      data: this.dataOffres,
      columns: [
        { data: 'port' },
        { data: "activite"},
        { data: "user"},
        { data: 'dateValidite'}
      ],
      columnDefs: [{ 'targets': 3, type: 'date-euro' }],
      "language": {
        "paginate": {
          "previous":'«',
          "next":'»'
        }
      },
      "searching": false,
      "info": false,
      "lengthChange": false,
      "order": [],
      "pageLength": 16
    });
    // var b = this.router;
    // $('#offres tbody').on('click', 'tr',function(e){
    //   var data = $('#offres').DataTable().row(this).data();
    //   b.navigate(["services/appel-concurrence2/"+data.ID]);
    // });
  }
  reload() {
    $('#offres').DataTable().clear();
    $('#offres').DataTable().rows.add(this.dataOffres);
    $('#offres').DataTable().columns.adjust().draw();
  }
  lancerFilter(filter) {
    this.filter = filter;
    this.dataOffres = [];
    if(filter.port== '' && filter.prestation ==  ''){
      
      this.dataOffres = this.dataOffresbrute;
    }else{
      this.dataOffres = this.transform(this.OffresGlobals, filter);
    }
    this.lenth = this.dataOffres.length;
    if (this.slick != null) {
      this.reload();
    } else {
      setTimeout(() => this.sliderAppel(), 100);
    }
  }
  transform(objet, filters): any[] {
    return objet.filter(element => {
      let a = true;
      //filters.port && element['port']? a = a && ((element['port'] as string).toUpperCase().includes(filters.Objet.toUpperCase())) : null;
     // filters.Objet && element['Objet']? a = a && ((element['Objet'] as string).toUpperCase().includes(filters.Objet.toUpperCase()) || (element['Objet_ar'] as string).toUpperCase().includes(filters.Objet.toUpperCase())) : null;
      filters.port && filters.port != '' ? a = a && filters.port == element.port : null;
      filters.prestation && filters.prestation != '' ? a = a && filters.prestation == element.activite : null;
      //filters.DatePlis && filters.DatePlis != '' ? a = a && new Date(filters.DatePlis).toLocaleDateString('fr') == new Date(element['Date_x0020_Ouverture']).toLocaleDateString('fr') : null;
      return a;
    });
  }


  
}


@Pipe({ name: 'offresFilter' })
export class OffresFilterPipe implements PipeTransform {
  transform(objet: [], filters: any): any[] {
    return objet.filter(element => {
      let a = true;
      filters.Objet ? a = a && (element['Objet'] as string).includes(filters.Objet.toUpperCase()) || (element['Objet_ar'] as string).toUpperCase().includes(filters.Objet.toUpperCase()) : null;
      filters.Region && filters.Region != '' ? a = a && filters.Region == element['RegionId'] : null;
      filters.Domain && filters.Domain != '' ? a = a && filters.Domain == element['Domaine'] : null;
      filters.DatePlis && filters.DatePlis != '' ? a = a && new Date(filters.DatePlis) == new Date(element['Date_x0020_Ouverture']) : null;
      return a;
    });
  }

}
